export default __webpack_public_path__ + "static/media/AdsWizzLogo.fb5bd849.png";